import { BarChart, Bar, CartesianGrid, XAxis, YAxis } from "recharts";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from "@/components/ui/chart";
import { CHART_COLORS } from "../utils/chartUtils";

interface BarChartViewProps {
  data: Array<Record<string, unknown>>;
  xAxis: string;
  yAxes: string[];
  config: ChartConfig;
}

/**
 * Bar chart visualization for dataset query results.
 * @param props - Chart data, axis configuration, and chart config
 * @returns A bar chart rendered inside a ChartContainer
 */
export default function BarChartView({
  data,
  xAxis,
  yAxes,
  config,
}: BarChartViewProps) {
  return (
    <ChartContainer config={config} className="min-h-[350px] w-full">
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border/50" />
        <XAxis dataKey={xAxis} fontSize={11} tickLine={false} />
        <YAxis fontSize={11} tickLine={false} axisLine={false} />
        <ChartTooltip content={<ChartTooltipContent />} />
        {yAxes.map((col, i) => (
          <Bar
            key={col}
            dataKey={col}
            fill={CHART_COLORS[i % CHART_COLORS.length]}
            radius={[3, 3, 0, 0]}
          />
        ))}
      </BarChart>
    </ChartContainer>
  );
}
